import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from 'screens/components/basic/Button';
import SelectInput from 'screens/components/basic/SelectInput';
import LOOKUP from 'constants/lookup';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import BranchSelectAutoCompleteInput from 'screens/components/basic/BranchSelectAutoCompleteInput';
import CardSimple from 'screens/components/basic/CardSimple';

const componentName = "CombinedSales";
class Header extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let props = this.props;
        return (
            <CardSimple className="p-1">
                <div className="row row_margin_none">
                    <div className="col-xs-6 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                        <DatePickerInput
                            name={componentName + LOOKUP.report.common.beginDate.name}
                            floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                            hintText={LOOKUP.report.common.beginDate.label + "*"}
                            fullWidth={true}
                            required
                        />
                    </div> {/* .col */}
                    <div className="col-xs-6 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                        <DatePickerInput
                            name={componentName + LOOKUP.report.common.endDate.name}
                            floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                            hintText={LOOKUP.report.common.endDate.label + "*"}
                            fullWidth={true}
                        />
                    </div> {/* .col */}
                    <div className="col-xs-12 col-sm-6 col-md-3 col-lg-2 col-xl-3">
                        <BranchSelectAutoCompleteInput
                            name={componentName + LOOKUP.report.common.branchName}
                            label={LOOKUP.report.common.branch + "*"}
                        />
                    </div> {/* .col */}

                    <div className="col-xs-12 col-sm-6 col-md-3 col-lg-2 col-xl-3">
                        <SelectInput
                            name={componentName + "GroupBy"}
                            fullWidth={true}
                            defaultValue={"4"}
                            label={"Report By"}
                            floatingLabelText={"Report By"}
                            hintText={"Report By"}
                            options={props.groups && props.groups.length > 0 ? props.groups : []}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-3 col-lg-2 col-xl-3">
                        <SelectInput
                            name={componentName + "Type"}
                            fullWidth={true}
                            defaultValue={"3"}
                            label={"Sale Type"}
                            floatingLabelText={"Sale Type"}
                            hintText={"Sale Type"}
                            options={props.types && props.types.length > 0 ? props.types : []}
                        />
                    </div>
                    {
                        props.onlineType == 2 &&
                        <div className="col-xs-12 col-sm-6 col-md-3 col-lg-2 col-xl-3">
                            <SelectInput
                                name={componentName + "OnlineType"}
                                fullWidth={true}
                                defaultValue={"5"}
                                label={"Online Sale Type"}
                                floatingLabelText={"Online Sale Type"}
                                hintText={"Online Sale Type"}
                                options={props.onlineTypes && props.onlineTypes.length > 0 ? props.onlineTypes : []}
                            />
                        </div>
                    }
                    <div className="col-xs-12 col-sm-12 col-md-5 col-lg-12 col-xl-5 mb_xs p-0">
                        <Button
                            type="IconInButton"
                            className="pull-right ml-1 btnNewBrandPOS"
                            name={componentName + LOOKUP.report.common.viewReport.name}
                            label={LOOKUP.report.common.viewReport.label}
                            icon={<VisibilityIcon />}
                            onTouchTap={props.showBody}
                        />
                        <Button
                            type="DownloadButton"
                            className="pull-right btnNewBrandPOS"
                            name={componentName + LOOKUP.report.common.downloadReport.name}
                            label={LOOKUP.report.common.downloadReport.label}
                            onTouchTap={props.download}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <p><b>Note: </b><strong className="blue-text"><i>Only completed & partially refunded orders will be counted in this report, the profit may change based on the change in the cost of the products.</i></strong></p>
                        <p><strong className="blue-text"><i>Gross Profit is calculated from (Net Sales - Weighted Average Costs)</i></strong></p>
                    </div>
                </div>
            </CardSimple>
        );
    }
}

const mapStateToProps = state => {
    return {
        onlineType: state.form.CombinedSalesType
    };
};

export default connect(mapStateToProps)(Header);
